import React, { ReactNode } from 'react';

import { styled } from '@mui/material/styles';
import classnames from 'classnames';

import { Card as MuiCard, CardContent, CardMedia } from '@mui/material';

type Props = {
  className?: string;
  href?: string;
  media?: ReactNode;
  header: ReactNode;
  content: ReactNode;
};

export const Card = styled(({ className, media, header, content }: Props) => (
  <MuiCard className={classnames('Card', className)}>
    {media && <CardMedia className='media'>{media}</CardMedia>}
    <CardContent>
      <div className='header'>{header}</div>
      <div className='content'>{content}</div>
    </CardContent>
  </MuiCard>
))<Props>`
  padding: 1%;
  flex: 1;
  background-color: unset;
  box-shadow: unset;

  .media {
    padding-left: ${(p) => p.theme.spacing(4)};
  }

  .header {
    font-size: 0.9rem;
    line-height: 145%;

    img {
      height: auto;
      width: 100%;
      margin-bottom: 15px;
    }
  }
`;
